import React from "react";
import { cx } from "@digitalisation/enlixy-comp";

interface ConnectionStatusProps {
  /** Green dot when true (data flowing), amber pulse when false (waiting). */
  connected: boolean;
  label: string;
  className?: string;
}

/**
 * Shared connection-status line (colored dot + label) for every
 * condition-monitoring screen, so "waiting / connected" looks identical
 * across motor, energy, and future screens.
 */
const ConnectionStatus: React.FC<ConnectionStatusProps> = ({
  connected,
  label,
  className,
}) => (
  <div className={cx("flex items-center gap-2", className)}>
    <span
      className={cx(
        "w-2 h-2 rounded-full",
        connected ? "bg-green-500" : "bg-amber-500 animate-pulse",
      )}
    />
    <span className="text-sm text-gray-600 dark:text-gray-400">{label}</span>
  </div>
);

export default ConnectionStatus;
